import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { faqs } from '../data/mock';

const FAQPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const additionalFaqs = [
    {
      question: "What devices can I use Tenses on?",
      answer: "Tenses works on any device with a modern web browser. We also have dedicated iOS and Android apps for the best mobile experience."
    },
    {
      question: "How accurate is the AI feedback?",
      answer: "Our AI models are trained on millions of English speech and writing samples. They achieve over 95% accuracy compared to human expert evaluations."
    },
    {
      question: "Can I use Tenses for business English?",
      answer: "Yes! Our activities cover professional communication, including business writing, presentation skills, and formal vocabulary."
    },
    {
      question: "Is my data secure?",
      answer: "Absolutely. We use industry-standard encryption and never share your personal data with third parties. Your audio recordings are processed securely and deleted after analysis."
    },
    {
      question: "Do you offer group or enterprise plans?",
      answer: "Yes, we offer special pricing for schools, universities, and businesses. Contact our sales team for custom solutions."
    },
    {
      question: "How long does it take to get certified?",
      answer: "Most users complete all 11 modules and earn their TPI certification in 2-3 months with consistent daily practice of 30-45 minutes."
    }
  ];

  const allFaqs = [...faqs, ...additionalFaqs];

  return (
    <div className="min-h-screen">
      <Header />
      
      <main className="pt-24 pb-16">
        <section className="section">
          <div className="text-center mb-12">
            <h1 className="heading-1 mb-4">Frequently Asked Questions</h1>
            <p className="body-large max-w-2xl mx-auto">
              Everything you need to know about Tenses and TPI certification.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {allFaqs.map((faq, index) => (
              <div key={index} className="border-b border-black/10">
                <button
                  className="w-full py-6 flex items-center justify-between text-left"
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                >
                  <span className="font-medium text-[#1a1a2e] pr-4">{faq.question}</span>
                  <ChevronDown 
                    className={`w-5 h-5 text-[#83928c] transition-transform flex-shrink-0 ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {openFaq === index && (
                  <div className="pb-6 animate-fade-in-up">
                    <p className="text-[#83928c]">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-[#83928c] mb-4">
              Still have questions?
            </p>
            <Link to="/contact" className="btn-blue">
              Contact Support
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FAQPage;
